import React from 'react'
import SingleScrollflyto from './SingleScrollflyto'
import styled from 'style'

const Scrollflyto = props => {
  return (
    <ScrollflytoContainer>
      <ScrollflytoWrapper>
        {props.scrollflyto.map((item, index) => (
          <SingleScrollflyto key={index} title={item.title} text={item.text} />
        ))}

      </ScrollflytoWrapper>
    </ScrollflytoContainer>
  )
}

const ScrollflytoContainer = styled.section`
  max-height: 400px;
`

const ScrollflytoWrapper = styled.div`
  font-family: -apple-system,BlinkMacSystemFont,"Helvetica Neue","Roboto","Segoe UI","Arial","Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  "Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  background-color: #fafafa;
  font: "Neue Helvetica";
  font-size: 16rem;
  
`

export default Scrollflyto
